export default "__VITE_ASSET__UvRejGWK__"